module.exports = __webpack_public_path__ + "img/培训提升.80559453.svg";